import styled from 'styled-components';
import { Checkbox, Form, Select } from 'antd';

import { DropdownWithDots } from '../../components/popovers';
import ButtonWithLoader from '../../components/ui-helpers/button-with-loader';
import { tangerineGradientRevert } from '../../styles';
import { Title } from '../styled-components';

export const SectionWrapper = styled.div`
  height: 960px;
  border: 1px solid ${({ theme }) => theme.colors.borderLightSilver};
  border-radius: 4px;
  padding-top: 12px;
  display: flex;
  flex-direction: column;
`;

export const CreateButton = styled(ButtonWithLoader)`
  height: 46px;
  width: 170px;
  border-radius: 30px;
  font-size: 16px;

  &:disabled {
    color: ${({ theme }) => theme.colors.white};
  }

  &:hover,
  &:focus {
    ${tangerineGradientRevert}
  }
`;

export const TitleS = styled(Title)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;

  b {
    height: 18px;
    width: 18px;
    line-height: 18px;
    font-size: 10px;
    color: ${({ theme }) => theme.colors.borderSilverDark};
    background-color: ${({ theme }) => theme.colors.geyser};
    display: inline-block;
    border-radius: 50%;
    font-weight: bold;
    margin: 4px 0 0 4px;
  }
`;

export const TaskContainer = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 20px;
  padding: 13px;
  overflow: auto;
  background-color: ${({ theme }) => theme.colors.catskillWhite};
`;

export const CheckboxS = styled(Checkbox)`
  margin-bottom: 13px;
  text-transform: capitalize;

  .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.fontTangerine};
    border-color: ${({ theme }) => theme.colors.fontTangerine};
    border-radius: 3px;
  }
`;

export const FormItem = styled(Form.Item)`
  margin-bottom: 10px;

  label {
    color: ${({ theme }) => theme.colors.fontSilverDark};
  }
  .ant-form-item-label {
    line-height: 2;
  }
  .ant-form-explain {
    padding-top: 10px;
  }

  .ant-input,
  .ant-time-picker-large .ant-time-picker-input,
  .ant-select-selection__placeholder {
    font-size: 13px;
  }

  textarea {
    resize: none;
  }
`;

export const SelectS = styled(Select)`
  font-size: 14px;

  .ant-select-selection--multiple {
    max-height: 80px;
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .ant-select-selection__choice {
    background: #fff5ed;
    border: 1px solid #fd740d;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.2;
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.fontTangerine};
  }

  svg {
    fill: ${({ theme }) => theme.colors.fontTangerine};
  }
`;

export const ButtonWithLoaderS = styled(ButtonWithLoader)`
  border-radius: 30px;
  width: 120px;
  height: 29px;
  margin: 10px 3px 0 3px;
  cursor: pointer;
  font-size: 16px;

  &:hover,
  &:focus {
    ${tangerineGradientRevert}
  }
`;

export const CancelButton = styled(ButtonWithLoaderS)`
  background: ${({ theme }) => theme.colors.fontSilver};

  &:disabled {
    color: ${({ theme }) => theme.colors.white};
    opacity: 0.4;
  }

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.colors.fontSilverLighter};
  }
`;

export const CreateTaskButton = styled.button`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 9px rgba(0, 0, 0, 0.0801191);
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.colors.fontTangerine};
  margin-bottom: 13px;
  width: 100%;
  border: none;
  cursor: pointer;
  padding: 12px 10px;
`;

export const DropdownWithDotsS = styled(DropdownWithDots)`
  transform: rotate(90deg);
  width: 20px;
  height: 28px;
  background-color: ${({ theme }) => theme.colors.backgroundLightSilver};
  border-radius: 3px;
  flex-shrink: 0;
  margin-left: 10px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.catskillWhite};
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  word-break: break-word;
`;

export const FieldWrapper = styled.div`
  position: relative;
`;

export const StyledOption = styled(Select.Option)`
  display: flex;
  flex-direction: row;
`;



// WEBPACK FOOTER //
// ./src/modals/add-meeting-notes-modal/styled-components.js